import { useQuery } from "@tanstack/react-query";
import { getGlobalMarketMetrics } from "../services/ChartServices/ChartServices";

const useGlobalMarketMetrics = ({ enabled = true } = {}) => {
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: ["global-market-metrics"],
    queryFn: getGlobalMarketMetrics,
    staleTime: 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchInterval: 120 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
    enabled,
  });

  return {
    marketMetrics: data || null,
    isLoading,
    isFetching,
    isError,
    error: error || null,
    refetch,
  };
};

export default useGlobalMarketMetrics;
